<template>
  <DashboardContainer>
    <NewProjectCard :showSkipButton="false"></NewProjectCard>
  </DashboardContainer>
</template>

<script>
import DashboardContainer from "../../components/DashboardContainer";
import NewProjectCard from "../../components/project/NewProjectCard";

export default {
  components: {
    DashboardContainer,
    NewProjectCard
  }
};
</script>